import parseNavigation from './parseNavigation';

/** Menú del rol integrador: `tipo id | título | ícono | url`, anidado por tabulación. */
const integrativeNavigation = parseNavigation(`
group integrative-certificates | Certificados | account_tree
	item integrative-certificate-avaibles | Certificados disponibles | check_circle_outline | /certificates/integrative/avaibles
	item integrative-certificate-nominees | Certificados nominados | person_pin | /certificates/integrative/nominees
	item integrative-circularity-available | Certificados de circularidad disponibles | recycling | /circularity/available
	item integrative-circularity-nominations | Certificados de circularidad nominados | how_to_reg | /circularity/consult/nominations
group integrative-consults | Consultas | account_tree
	item integrative-received-transfer-info | Certificados recibidos | move_to_inbox | /integrative/consult/received-transfer-info
	item integrative-send-transfer-info | Certificados transferidos | send | /integrative/consult/send-transfer-info
	item integrative-circularity-received | Certificados de circularidad recibidos | move_to_inbox | /circularity/consult/received-transfer
	item integrative-circularity-sent | Certificados de circularidad transferidos | send | /circularity/consult/sent-transfer
group configuration | Configuración | account_tree
	item actors-new | Registrar Actor | person_add | /integrative/config/new-actor
	item actors | Actores Registrados | groups | /integrative/config/actors
`);

export default integrativeNavigation;
